import { combineReducers } from "@reduxjs/toolkit";

import ProfileReducer from "./auth/profile/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";

const rootReducer = combineReducers ({
    Profile: ProfileReducer,
    ForgetPassword: ForgetPasswordReducer,
});

export default rootReducer
